import * as Yup from 'yup';

const validationSchema = (t) => {
  const limitLow = t('goalSettings.currentBodyWeight.validation.limit.low');
  const limitHigh = t('goalSettings.currentBodyWeight.validation.limit.high');

  return Yup.object({
    weightValue: Yup.number()
      .min(40.1, t('goalSettings.currentBodyWeight.validation', { limit: limitLow }))
      .max(249.9, t('goalSettings.currentBodyWeight.validation', { limit: limitHigh }))
      .when('weightUnit', {
        is: (value) => value && value === 'lb',
        then: (schema) =>
          schema
            .min(88.4, t('goalSettings.currentBodyWeight.validation', { limit: limitLow }))
            .max(550.9, t('goalSettings.currentBodyWeight.validation', { limit: limitHigh })),
      }),
    goalWeightValue: Yup.number()
      .min(40.1, t('goalSettings.goalBodyWeight.validation', { min: '40 kg', max: '250 kg' }))
      .max(249.9, t('goalSettings.goalBodyWeight.validation', { min: '40 kg', max: '250 kg' }))
      .when('weightUnit', {
        is: (value) => value && value === 'lb',
        then: (schema) =>
          schema
            .min(
              88.4,
              t('goalSettings.goalBodyWeight.validation', { min: '88.4 lb', max: '551 lb' })
            )
            .max(
              550.9,
              t('goalSettings.goalBodyWeight.validation', { min: '88.4 lb', max: '551 lb' })
            ),
      }),
    dateOfBirth: Yup.date()
      .min(new Date(1900, 0, 1), 'biometric.birthDate.validation.min')
      .required('The field is required'),
    heightValue: Yup.number()
      .min(101, t('biometric.height.validation', { min: '101 cm', max: '249 cm' }))
      .max(249, t('biometric.height.validation', { min: '101 cm', max: '249 cm' }))
      .when('heightUnit', {
        is: (value) => value && value === 'in',
        then: (schema) =>
          schema
            .min(40, t('biometric.height.validation', { min: '3 ft 4 in', max: '8 ft 2 in' }))
            .max(98, t('biometric.height.validation', { min: '3 ft 4 in', max: '8 ft 2 in' })),
      }),
    acceptance: Yup.boolean()
      .oneOf([true], t('goalSettings.dietWarning.checkboxDeclaration.validationError'))
      .required(t('goalSettings.dietWarning.checkboxDeclaration.validationError')),
  });
};

export default validationSchema;
